import {
  IClientAccountForm,
  ICreateClientAccount,
} from 'services/client-account/types';

export const formToMutation = (
  form: IClientAccountForm
): ICreateClientAccount => ({
  name: form.label.name,
  labelId: form.label.id,
  users: form.users.map(u => u.id),
  artists: form.artists.map(u => u.id),
  tracks: form.tracks.map(u => u.id),
  digitalMusicProducts: form.digitalMusicProducts.map(u => u.id),
  physicalMusicProducts: form.physicalMusicProducts.map(u => u.id),
  merch: form.merch.map(u => u.id),
  channels: form.channels.map(u => u.id),
  videos: form.videos?.map(u => u.id) ?? [],
});
